import { Tooltip } from "components/Tooltip";

const LegendItem = ({
  color,
  label,
  isMobile,
  icon,
}: {
  color: string;
  label: string;
  isMobile: boolean;
  icon?: React.ReactNode;
}) => (
  <div
    key={label}
    className={`flex items-center gap-2 ${isMobile ? "" : "min-w-[200px]"}`}
  >
    <span
      className="w-4 h-4 shrink-0 rounded"
      style={{ backgroundColor: color }}
    />
    <span className="text-sm gap-0">
      {label === "Concurrent threads" ? (
        <Tooltip content="Number of scraping requests running simultaneously over the time period.">{label}</Tooltip>
      ) : (
        label
      )}
    </span>
  </div>
);

export default LegendItem;
